/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Shop_Home_Schedule_ToInputs */

const vi_shop_home_schedule_to = /** @type {(inputs: Shop_Home_Schedule_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đến ${i?.date}`)
};

/**

* @param {Shop_Home_Schedule_ToInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_schedule_to = /** @type {((inputs: Shop_Home_Schedule_ToInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Schedule_ToInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_schedule_to(inputs)
});